// Some of the colors of the admin theme are a copy of the
// default theme. Some of them are not being used, but were left
// here as a reference.

import { lightColorRoles } from '@hapana/shared/web/styles/material-ui/color-roles'

export const palette = {
  ...lightColorRoles,
  primary: {
    darkest: '#001518',
    dark: '#003239',
    main: '#004751',
    light: '#4D7E85',
    lightest: '#E6FBF5',
  },
  secondary: {
    darkest: '#1F153A',
    dark: '#473087',
    main: '#6645C1',
    light: '#947DD4',
    lightest: '#F0ECF9',
  },
  overlays: {
    default: 'rgba(30, 32, 38, 0.6)',
    dark: '#818285',
  },
  gradient: {
    workoutBackground: 'linear-gradient(180deg, #1E2026 0%, #3A3C45 100%)',
  },
  info: {
    darkest: '#1E2026',
    dark: '#1E2026',
    main: '#4B4D51',
    light: '#E4E4E5',
    lightest: '#F8F9F9',
  },
  blue: {
    lightest: '#E7F4FF',
    dark: '#0B68B3',
  },
  yellow: {
    lightest: '#FEFCE8',
    dark: '#854D0E',
  },
  green: {
    dark: '#21AB87',
    main: '#3DD5AE',
    lightest: '#D8F7EF',
  },
  orange: {
    dark: '#A45F1A',
    lightest: '#FFEEDE',
  },
  success: {
    darkest: '#003414',
    dark: '#00782F',
    main: '#00AC43',
    light: '#4DC57B',
    lightest: '#E6F7EC',
  },
  warning: {
    darkest: '#452302',
    dark: '#A15305',
    main: '#E67607',
    light: '#EE9F51',
    lightest: '#FDF1E6',
  },
  error: {
    darkest: '#460A0A',
    dark: '#A21616',
    main: '#E82020',
    light: '#EF6363',
    lightest: '#FDE9E9',
  },
  gray: {
    0: '#FFFFFF',
    3: '#F8F9F9',
    8: '#EDEEEE',
    12: '#E4E4E5',
    16: '#DBDBDC',
    40: '#A5A6A8',
    56: '#818285',
    64: '#6F7074',
    80: '#4B4D51',
    100: '#1E2026',
  },
  custom: {
    turquoise: {
      main: '#00CCC0',
      lightest: '#E6FAF9',
      dark: '#008F86',
    },
    navy: {
      deep: '#1A1A33',
    },
    blue: {
      light: '#9FD1D8',
      main: '#00A2E1',
    },
    table: {
      main: '#DBDBDC',
    },
    button: {
      hover: '#FFFFFF',
    },
    user: {
      header: '#F8F9F9',
      title: '#001518',
      subtitle: '#4B4D51',
      action: '#004751',
      background: '#FFFFFF',
    },
    attendanceStatus: {
      booked: {
        main: '#0D9488', // Dark teal
        background: '#E0F2F1', // Light blue-green
      },
      attended: {
        main: '#16A34A', // Medium green
        background: '#DCFCE7', // Light pastel green
      },
      noShow: {
        main: '#DC2626', // Red
        background: '#FEE2E2', // Light red
      },
      lateCancelled: {
        main: '#3683C0', // Dark blue
        background: '#E6F5FE', // Very light blue
      },
    },
  },
  content: {
    grey: '#42A4FF',
  },
  alertmessage: {
    iconColor: '#FBA61A',
  },
  pink: {
    lightest: '#FEEBF7',
    dark: '#A9287D',
  },
  // Figma Icon/All/* variables (2. Exports — Analytics library). Chart series
  // colours for the analytics trend charts — additive block, maps 1:1 to the
  // design tokens so no chart hardcodes a hex.
  icon: {
    teal: '#2EABBF',
    green: '#6EB522',
    orange: '#D17F2A',
    red: '#CD3134',
    purple: '#6B48CB',
    blue: '#00A2E1',
    light: '#848B89',
    default: '#636967',
  },
  alert: {
    danger: {
      lightest: '#FFE2E3',
      dark: '#A32326',
    },
    teal: {
      lightest: '#E0F7FA',
      dark: '#228292',
    },
    successV2: {
      lightest: '#EBF8DD',
      dark: '#528C15',
    },
    indigo: {
      lightest: '#E6E8FC',
      dark: '#29369C',
    },
    info: {
      background: '#E6F3F7',
      border: '#C5E4F2',
      text: '#00597B',
      icon: '#007DAE',
    },
  },
  aggregator: {
    main: '#0055FE',
  },
  attendance: {
    site: '#6B46C1',
    total: '#A45F1A',
  },
  link: {
    main: '#0082B4',
  },
  pdf: {
    border: '#e0e0e0',
    primary: '#1a1a1a',
    secondary: '#666666',
    tertiary: '#4a4a4a',
    question: '#333333',
    empty: '#999999',
  },
  paymentStatus: {
    paid: '#528C15',
    processing: '#FBA61A',
    failed: '#A32326',
  },
  // Tab tokens from the design system (Figma `Misc/Tabs/*`). Kept apart from
  // primary.*, which swaps between site and corporate scope — the design system
  // gives tabs one location-scoped value that holds at both.
  tabs: {
    enabledLocation: '#007DAE',
    default: '#636967',
  },
  badge: {
    brand: { background: '#EAF7F3', text: '#179574' },
    location: { background: '#E6F3F7', text: '#00597B', icon: '#007DAE', border: '#C5E4F2' },
    purple: { background: '#E9E4F9', text: '#3D208D' },
    pink: { background: '#FFD8F7', text: '#611C58' },
    warning: { background: '#FFE5CB', text: '#834C12' },
    success: { background: '#F0FFE0', text: '#3A640D' },
    neutral: { background: '#F4F6F5', text: '#636967' },
  },
}

export const settings_palette = {
  ...palette,
  primary: {
    darkest: '#00394f',
    dark: '#007aa9',
    main: '#00a2e1',
    light: '#0092cb',
    lightest: '#e6f6fc',
  },
  custom: {
    ...palette.custom,
    chip: {
      background: '#e6f6fc',
      text: '#00a2e1',
      main: '#1E202699',
    },
    user: {
      ...palette.custom.user,
      action: '#00a2e1',
    },
    attendanceStatus: {
      ...palette.custom.attendanceStatus,
    },
  },
}
